import { InMemoryCache } from '@apollo/client';

import possibleTypes from './possibleTypes.json';
import { typePolicies } from './typePolicies/typePolicies';

export const createCache = () =>
  new InMemoryCache({
    possibleTypes: possibleTypes.possibleTypes,
    typePolicies,
  });
